<section *ngIf="this.isAutenticadoHg" class="p-2 p-md-4">
  <div class="card mb-4">
    <div class="card">
      <div class="card-header mt-2 mb-2 bg-white row justify-content-between">
        <div class="col-8">
          <h3 class="fw-500 text-uppercase">
            Usuário HG:
            {{
              dadosSalvosUnion?.veiculo?.emailHg || "USUÁRIO HG NÃO ENCONTRADO"
            }}
          </h3>
        </div>
        <div class="col-4" *ngIf="hgFinalizado">
          <h3 class="fw-500 text-danger text-uppercase">
            *Avaliação finalizada
            {{ idAvaliacao === 0 ? "" : "  (Id " + idAvaliacao + ")" }}
          </h3>
        </div>
        <div class="col-4" *ngIf="existeErroHg">
          <div class="row">
            <h3 class="fw-500 text-danger text-uppercase">Erro encontrado:</h3>
            <button
              style="margin-left: 10px"
              class="btn btn-sm btn-danger"
              (click)="showErrorHg()"
            >
              Analisar
            </button>
          </div>
        </div>
        <div class="col-8">
          <h3 class="fw-500 text-uppercase">
            CNPJ:
            {{
              (dadosSalvosUnion?.veiculo?.cnpjHg | appCnpj) ||
                " NÃO ENCONTRADO, FAVOR ENTRAR EM CONTATO COM O NOSSO SUPORTE"
            }}
          </h3>
        </div>
      </div>
      <div class="card-header mt-4 bg-white row justify-content-between">
        <div class="col-12">
          <h3>Dados Complementares Integração</h3>
        </div>
      </div>

      <!-- ////////////////// MARCA MODELO VERSÃO ///////////////-->
      <div class="card-body row">
        <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 p-2">
          <label for="marcaId">Selecione a Marca</label>
          <select
            id="marcaId"
            #marcaId
            type="text"
            class="text-uppercase form-control"
            (change)="getListaModelosHg(marcaId.value, false, false)"
            [disabled]="hgFinalizado"
          >
            <option
              *ngIf="
                this.marcaInicial?.id == null || this.marcaInicial?.id == ''
              "
              value=""
            >
              SELECIONE
            </option>
            <option
              *ngIf="isVeiculoEncontradoHg || isVeiculoEncontradoUnion"
              [value]="marcaInicial?.id"
            >
              {{ marcaInicial?.name }}
            </option>
            <option *ngFor="let o of listaMarcas" [value]="o.id">
              {{ o.name }}
            </option>
          </select>
          <app-msg-erro [control]="form.controls.marcaId"></app-msg-erro>
        </div>
        <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 p-2">
          <label for="modeloId">Selecione o Modelo</label>
          <select
            id="modeloId"
            #modeloId
            type="text"
            class="text-uppercase form-control"
            (change)="getListaVersoesHg(modeloId.value, false, false)"
            [disabled]="hgFinalizado"
          >
            <option
              *ngIf="
                this.modeloInicial?.id == null || this.modeloInicial?.id == ''
              "
              value=""
            >
              SELECIONE
            </option>
            <option
              *ngIf="isVeiculoEncontradoHg || isVeiculoEncontradoUnion"
              [value]="modeloInicial?.id"
            >
              {{ modeloInicial?.name }}
            </option>
            <option *ngFor="let o of listaModelos" [value]="o.id">
              {{ o.name }}
            </option>
          </select>
          <app-msg-erro [control]="form.controls.modeloId"></app-msg-erro>
        </div>
        <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 p-2">
          <label for="versaoId">Selecione a Versão</label>
          <select
            id="versaoId"
            #versaoId
            type="text"
            class="text-uppercase form-control"
            (change)="setVersaoHg(versaoId.value)"
            [disabled]="hgFinalizado"
          >
            <option
              *ngIf="
                this.versaoInicial?.id == null || this.versaoInicial?.id == ''
              "
              value=""
            >
              SELECIONE
            </option>
            <option
              *ngIf="isVeiculoEncontradoHg || isVeiculoEncontradoUnion"
              [value]="versaoInicial?.id"
            >
              {{ versaoInicial?.name }}
            </option>
            <option *ngFor="let o of listaVersoes" [value]="o.id">
              {{ o.name }} - {{ o.year }}
            </option>
          </select>
          <app-msg-erro [control]="form.controls.versaoId"></app-msg-erro>
        </div>
      </div>

      <!-- ////////////////// DADOS VEÍCULO ///////////////-->
      <div class="card-body row">
        <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12 p-2">
          <label for="placa">Placa</label>
          <input
            required
            autocomplete="off"
            type="text"
            class="text-uppercase form-control input-validate"
            name="placa"
            id="placa"
            [textMask]="masks.placa"
            [formControl]="form.controls.placa"
          />
          <app-msg-erro [control]="form.controls.placa"></app-msg-erro>
        </div>
        <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12 p-2">
          <label for="chassi">Chassi</label>
          <input
            type="text"
            class="text-uppercase form-control input-validate"
            minlength="15"
            maxlength="17"
            required
            autocomplete="off"
            name="chassi"
            id="chassi"
            [formControl]="form.controls.chassi"
          />
          <app-msg-erro [control]="form.controls.chassi"></app-msg-erro>
        </div>
        <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12 p-2">
          <label for="renavam">Renavam</label>
          <input
            type="text"
            class="text-uppercase form-control input-validate"
            required
            autocomplete="off"
            name="renavam"
            id="renavam"
            [formControl]="form.controls.renavam"
          />
          <app-msg-erro [control]="form.controls.renavam"></app-msg-erro>
        </div>
        <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12 p-2">
          <label for="motor">Motor (Cilindradas)</label>
          <input
            type="number"
            class="text-uppercase form-control input-validate"
            required
            autocomplete="off"
            name="motor"
            id="motor"
            maxlength="10"
            oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
            [formControl]="form.controls.motor"
          />
          <app-msg-erro [control]="form.controls.motor"></app-msg-erro>
        </div>
        <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12 p-2">
          <label for="quilometragem">Quilometragem</label>
          <input
            type="number"
            class="form-control input-validate"
            required
            autocomplete="off"
            name="quilometragem"
            id="quilometragem"
            [formControl]="form.controls.quilometragem"
          />
          <app-msg-erro [control]="form.controls.quilometragem"></app-msg-erro>
        </div>
        <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12 p-2">
          <label for="anoFabricacao">Ano Fabricação</label>
          <input
            type="number"
            class="form-control input-validate"
            required
            autocomplete="off"
            name="anoFabricacao"
            id="anoFabricacao"
            [formControl]="form.controls.anoFabricacao"
          />
          <app-msg-erro [control]="form.controls.anoFabricacao"></app-msg-erro>
        </div>
        <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12 p-2">
          <label for="anoModelo">Ano Modelo</label>
          <input
            type="number"
            class="form-control input-validate"
            required
            autocomplete="off"
            name="anoModelo"
            id="anoModelo"
            [formControl]="form.controls.anoModelo"
          />
          <app-msg-erro [control]="form.controls.anoModelo"></app-msg-erro>
        </div>
        <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12 p-2">
          <label for="portas">Nº de Portas</label>
          <select
            id="portas"
            #portas
            [formControl]="form.controls.portas"
            type="text"
            class="text-uppercase form-control"
          >
            <option value="">SELECIONE</option>
            <option *ngFor="let o of listaPortas" [value]="o">
              {{ o }}
            </option>
          </select>
          <app-msg-erro [control]="form.controls.portas"></app-msg-erro>
        </div>
        <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12 p-2">
          <label for="transmissao">Transmissão</label>
          <select
            id="transmissao"
            #transmissaoId
            [formControl]="form.controls.transmissaoId"
            type="text"
            class="text-uppercase form-control"
          >
            <option value="">SELECIONE</option>
            <option *ngFor="let o of listaTransmissoes" [value]="o.id">
              {{ o.name }}
            </option>
          </select>
          <app-msg-erro [control]="form.controls.transmissaoId"></app-msg-erro>
        </div>
        <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12 p-2">
          <label for="bodyType">Carroceria</label>
          <select
            id="bodyType"
            #bodyTypeId
            [formControl]="form.controls.bodyTypeId"
            type="text"
            class="text-uppercase form-control"
          >
            <option value="">SELECIONE</option>
            <option *ngFor="let o of listaBody" [value]="o.id">
              {{ o.name }}
            </option>
          </select>
          <app-msg-erro [control]="form.controls.bodyTypeId"></app-msg-erro>
        </div>
        <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12 p-2">
          <label for="combustivel">Combustível</label>
          <select
            id="combustivel"
            #combustivelId
            [formControl]="form.controls.combustivelId"
            type="text"
            class="text-uppercase form-control"
          >
            <option value="">SELECIONE</option>
            <option *ngFor="let o of listaCombustiveis" [value]="o.id">
              {{ o.name }}
            </option>
          </select>
          <app-msg-erro [control]="form.controls.combustivelId"></app-msg-erro>
        </div>
        <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12 p-2">
          <label for="cor">Cor</label>
          <select
            id="cor"
            #corId
            [formControl]="form.controls.corId"
            type="text"
            class="text-uppercase form-control"
          >
            <option value="">SELECIONE</option>
            <option *ngFor="let o of listaCores" [value]="o.id">
              {{ o.name }}
            </option>
          </select>
          <app-msg-erro [control]="form.controls.corId"></app-msg-erro>
        </div>
        <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12 p-2">
          <label for="kind">Tipo Veículo</label>
          <select
            id="kind"
            #kindId
            [formControl]="form.controls.kindId"
            type="text"
            class="text-uppercase form-control"
          >
            <option value="">SELECIONE</option>
            <option *ngFor="let o of listaKinds" [value]="o.id">
              {{ o.name }}
            </option>
          </select>
          <app-msg-erro [control]="form.controls.kindId"></app-msg-erro>
        </div>
        <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12 p-2">
          <label for="origem">Origem</label>
          <select
            id="origem"
            #origemId
            [formControl]="form.controls.origemId"
            type="text"
            class="text-uppercase form-control"
          >
            <option value="">SELECIONE</option>
            <option *ngFor="let o of listaOrigens" [value]="o.id">
              {{ o.name }}
            </option>
          </select>
          <app-msg-erro [control]="form.controls.origemId"></app-msg-erro>
        </div>
      </div>

      <!-- ////////////////// LISTA OPCIONAIS ///////////////-->
      <div class="card-header mt-1 bg-white">
        <h3>Opcionais</h3>
      </div>
      <div class="card-body row">
        <div class="col py-2 px-1">
          <p-pickList
            [source]="listaOpcionais"
            [target]="listaOpcionaisSelecionados"
            sourceHeader="Adicionar itens opcionais"
            targetHeader="Remover itens opcionais"
            [dragdrop]="true"
            [responsive]="true"
            [sourceStyle]="{ height: '10rem' }"
            [targetStyle]="{ height: '10rem' }"
            filterBy="name"
            sourceFilterPlaceholder="Procure pelo opcional"
            targetFilterPlaceholder="Procure pelo opcional"
            (onMoveToTarget)="opcionaisSelecionados($event.items)"
            (onMoveToSource)="opcionaisRemovidos($event.items)"
            [showSourceControls]="false"
            [showTargetControls]="false"
            [disabled]="hgFinalizado"
          >
            <ng-template let-item pTemplate="item">
              <span class="text-uppercase">{{ item?.name }}</span>
            </ng-template>
          </p-pickList>
          <app-msg-erro
            [control]="form.controls.listaItensOpcionais"
          ></app-msg-erro>
        </div>
      </div>

      <!-- ////////////////// ITENS AVALIADOS ///////////////-->
      <div class="card-header mt-1 bg-white">
        <h3>Itens para Avaliação</h3>
      </div>
      <div class="card-body row">
        <div class="col py-2 px-1">
          <p-pickList
            [source]="listaItensAvaliacao"
            [target]="listaItensAvaliacaoSelecionados"
            sourceHeader="Adicionar itens avaliados"
            targetHeader="Remover itens avaliados"
            [dragdrop]="true"
            [responsive]="true"
            [sourceStyle]="{ height: '10rem' }"
            [targetStyle]="{ height: '10rem' }"
            filterBy="name"
            sourceFilterPlaceholder="Procure pelo item avaliado"
            targetFilterPlaceholder="Procure pelo item avaliado"
            (onMoveToTarget)="itensAvaliadosSelecionados($event.items)"
            (onMoveToSource)="itensAvaliadosRemovidos($event.items)"
            [showSourceControls]="false"
            [showTargetControls]="false"
            [disabled]="hgFinalizado"
          >
            <ng-template let-item pTemplate="item">
              <span class="text-uppercase">{{ item?.name }}</span>
            </ng-template>
          </p-pickList>
          <app-msg-erro
            [control]="form.controls.listaItensAvaliacao"
          ></app-msg-erro>
        </div>
      </div>
      <div class="card-body row text-center">
        <div
          class="col-lg-6 col-md-6 col-sm-12 py-2 px-1 mt-2 mb-1"
          *ngFor="let item of listaItensAvaliacaoSelecionados; let i = index"
        >
          <div class="text-uppercase">
            <h3>{{ item.name }}</h3>
            <div
              class="form-check form-check-inline"
              *ngFor="
                let classificacao of listaClassificacoesAvaliacao;
                let c = index
              "
            >
              <input
                mdbRadio
                class="form-check-input"
                type="radio"
                name="{{ item.name }}"
                id="{{ item.name }}{{ classificacao.id }}"
                value="{{ classificacao.id }}"
                (change)="itemAvaliadoCheck(item, classificacao)"
                [disabled]="hgFinalizado"
              />

              <label class="form-check-label" for="statusAvaliacao{{ i }}"
                >{{ classificacao.name }}
              </label>
            </div>
            <div class="card-body row">
              <div class="col py-2 px-1">
                <textarea
                  name="obsItem"
                  #obsItem
                  placeholder="Observações do item..."
                  rows="2"
                  wrap="hard"
                  autocomplete="off"
                  id="obsItem{{ item.name }}"
                  style="resize: none; padding: 0.75rem"
                  (keyup)="itemAvaliadoObservacaoKeyUp(item, obsItem.value)"
                  [disabled]="hgFinalizado"
                  hidden
                  [value]="item.observacao || ''"
                ></textarea>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- ////////////////// OBSERVAÇÃO DA AVALIAÇÃO ///////////////-->
      <div class="card-header mt-4 bg-white">
        <h3>Observações da Avaliação</h3>
      </div>
      <div class="card-body row">
        <div class="col py-2 px-1">
          <textarea
            name="obsAvaliacaoHg"
            placeholder="Observações da avaliação..."
            rows="8"
            wrap="hard"
            [formControl]="form.controls.obsAvaliacaoHg"
            autocomplete="off"
            class="form-control input-validate"
            name="obsAvaliacaoHg"
            id="obsAvaliacaoHg"
          ></textarea>
          <app-msg-erro [control]="form.controls.obsAvaliacaoHg"></app-msg-erro>
        </div>
      </div>
      <div class="card-footer d-flex justify-content-end">
        <button
          [disabled]="
            hgFinalizado || form.invalid || form.hasError('minlength')
          "
          (click)="salvarAvaliacaoHg()"
          class="btn btn-lg btn-success px-lg-5"
        >
          Confirmar
        </button>
      </div>
    </div>
  </div>
</section>


<section *ngIf="!this.isAutenticadoHg" class="p-2 p-md-4">
  <div class="card mb-4">
    <div class="card">
      <div class="card-header mt-2 mb-2 bg-white row justify-content-between">
        <div class="col-8">
          <h3 class="fw-500 text-uppercase">
           Falha na autenticação
          </h3>
          <h3 class="fw-500">
            Tente realizar o login novamente. Caso problema persistir, favor entrar em contato com nosso suporte.
          </h3>
        </div>
      </div>
      <div class="row">
        <div *ngIf="!isAutenticadoHg" class="card" style="width: 40%;">
          <div class="card-body">
            <form>
              <div class="form-group">
                <label for="email">Nome de Usuário:</label>
                <input #email type="email" class="form-control" id="email" ng-model="email" required>
              </div>
              <div class="form-group">
                <label for="senha">Senha:</label>
                <input #senha type="password" class="form-control" id="senha" ng-model="senha" required>
              </div>
              <button type="submit" (click)="reAuthHg(email.value, senha.value)" class="btn btn-primary">Login</button>
            </form>
          </div>
        </div>
        <div *ngIf="isAutenticadoHg" class="card" style="width: 40%;">
          <div class="card-body">
            <h4>Autenticação concluida</h4>
            <p>{{emailHg}}</p>
            <br>
            <button (click)="deslogar()" class="btn btn-primary">Desconectar</button>
          </div>
        </div>
        <br>
    </div>
  </div>
  </div>
</section>
